import {OEC_PARTNERS_LOGO} from "./utils";

export type ListedCompany = { name?: string; logo?: string };

const partnerNameKey = (name: string) => name.trim().toLowerCase().replace(/\s+/g, " ");

const reservedPartnerNames = new Set([
    ...OEC_PARTNERS_LOGO.map((partner) => partnerNameKey(partner.name)),
    "giz",
]);

export const logosFromCompanies = (companies: ListedCompany[]) => {
    const seen = new Set(reservedPartnerNames);
    return companies
        .map((company) => ({name: (company.name || "").trim(), src: company.logo || ""}))
        .filter((company) => {
            const key = partnerNameKey(company.name);
            if (!company.name || !company.src || company.src.includes("company-placeholder") || seen.has(key)) {
                return false;
            }
            seen.add(key);
            return true;
        })
        .sort((left, right) => left.name.localeCompare(right.name));
};
